import Swiper from "swiper/bundle";
import accordion from "./components/accordion";

export default function sustainabilityJs() {
	document.querySelectorAll('[data-js="accordion"]').forEach((elem) => {
		accordion(elem, true, document.querySelector(".accordionElementsBlock"));
	});

	var sustainabilityPromoCardTitle = new Swiper(
		".sustainabilityPromoCardTitle",
		{
			spaceBetween: 15,
			slidesPerView: 1,
			freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
				1280: {
					slidesPerView: 5,
					spaceBetween: 50,
				},
			},
		}
	);

	var sustainabilityPromoCard = new Swiper(".sustainabilityPromoCard", {
		autoHeight: true,
		slidesPerView: 1,
		effect: "fade",
		thumbs: {
			swiper: sustainabilityPromoCardTitle,
		},
	});

	// sliderThumbs(".sustainabilityPromoCardTitle", sustainabilityPromoCard);

	const srcLinks = document.querySelectorAll(".src-link");

	srcLinks.forEach((elem) => {
		const title = elem.querySelector("h3");
		const link = elem.querySelector(".hidden");
		const targetTitle = document.querySelector(".target-link .title");
		const targetLink = document.querySelector(".target-link .link");
		elem.addEventListener("click", () =>
			changePdfLink(targetLink, targetTitle, link, title),
			console.log(title),
		);
	});

	srcLinks.forEach((elem) => {
		elem.addEventListener("click", () =>{
			document.querySelector('section.active-title') && document.querySelector('section.active-title').classList.remove('active-title');
			elem.classList.add("active-title");
		});
	});

	function setPdfLink(elem, callback) {
		const title = elem.querySelector("h3");
		const link = elem.querySelector(".hidden");
		const targetTitle = document.querySelector(".target-link .title");
		const targetLink = document.querySelector(".target-link .link");
		callback(targetLink, targetTitle, link, title);
	}

	setPdfLink(document.querySelector(".src-link"), changePdfLink);

	function changePdfLink(targetLink, targetTitle, link, title) {
		targetLink.innerHTML = link.innerHTML;
		targetTitle.innerHTML = title.innerHTML;
	}

	const EfficiencyMeasuresTitle = new Swiper(".measuresTitle", {
		spaceBetween: 15,
		slidesPerView: "auto",
		freeMode: true,
		watchSlidesProgress: true,
	});
	const EfficiencyMeasuresPromoCard = new Swiper(".measuresPromoCard", {
		autoHeight: false,
		slidesPerView: 1,
		effect: "fade",
		thumbs: {
			swiper: EfficiencyMeasuresTitle,
		},
	});

	// sliderThumbs(".measuresTitle", EfficiencyMeasuresPromoCard);

	EfficiencyMeasuresPromoCard.on("transitionEnd", function () {
		let actInd = EfficiencyMeasuresPromoCard.activeIndex;
		EfficiencyMeasuresTitle.slideTo(actInd);
	});

	function hoveredChild() {
		const targetTitle = document.querySelector(".target-link .title");
		const targetLink = document.querySelector(".target-link .link");
		targetLink.addEventListener("mouseenter", () => {
			targetTitle.classList.add("hovered");
		});
		targetLink.addEventListener("mouseleave", () => {
			targetTitle.classList.remove("hovered");
		});
	}
	hoveredChild();
}

export function sliderThumbs(thumbsHtmlClass, mainSlider) {
	document
		.querySelector(`${thumbsHtmlClass} .swiper-slide`)
		.classList.add("swiper-slide-thumb-active");

	document
		.querySelectorAll(`${thumbsHtmlClass} .swiper-slide`)
		.forEach((elem, index) => {
			elem.addEventListener("click", function () {
				mainSlider.slideTo(index);
			});
		});

	mainSlider.on("slideChange", function () {
		document
			.querySelector(`${thumbsHtmlClass} .swiper-slide-thumb-active`)
			.classList.remove("swiper-slide-thumb-active");
		document
			.querySelector(
				`${thumbsHtmlClass} .swiper-slide:nth-child(${
					mainSlider.activeIndex + 1
				})`
			)
			.classList.add("swiper-slide-thumb-active");
	});
}
